import { Edit } from "@mui/icons-material";
import { ReactElement } from "react";

import { ListDataBrokersQuery } from "~frontend/__generated__/graphql";
import Table from "~frontend/components/Table";
import Archive from "~frontend/components/icons/Archive";
import Unarchive from "~frontend/components/icons/Unarchive";

export type DataBrokerTableRow = ListDataBrokersQuery["listDataBrokers"][0];

export default function DataBrokerTable({
  rows,
  page,
  handleChangePage,
  rowsPerPage,
  handleChangeRowsPerPage,
  totalCount,
  onEdit,
  onArchive,
  onUnarchive,
}: {
  rows: DataBrokerTableRow[];
  page: number;
  handleChangePage: (newPage: number) => void;
  rowsPerPage: number;
  handleChangeRowsPerPage: (newRowsPerPage: number) => void;
  totalCount: number;
  onEdit: (dataBroker: DataBrokerTableRow) => void;
  onArchive: (dataBrokerId: string) => Promise<void>;
  onUnarchive: (dataBrokerId: string) => Promise<void>;
}): ReactElement {
  return (
    <Table
      columns={[
        {
          key: "name",
          title: "Name",
          renderValue: dataBroker => <span>{dataBroker.name}</span>,
          align: "left",
        },
        {
          key: "slug",
          title: "Slug",
          renderValue: dataBroker => <span>{dataBroker.slug}</span>,
          align: "left",
        },
        {
          key: "service",
          title: "Service",
          renderValue: dataBroker => <span>{dataBroker.service}</span>,
          align: "left",
        },
        {
          key: "createdAt",
          title: "Created At",
          renderValue: dataBroker =>
            new Date(dataBroker.createdAt).toLocaleString(),
          align: "left",
        },
        {
          key: "archivedAt",
          title: "Archived At",
          renderValue: dataBroker =>
            dataBroker.archivedAt
              ? new Date(dataBroker.archivedAt).toLocaleString()
              : "",
          align: "left",
        },
      ]}
      rows={rows}
      rowActions={dataBroker => [
        {
          id: "edit",
          type: "button" as const,
          icon: <Edit />,
          tooltipLabel: "Edit Data Broker",
          onClick: () => onEdit(dataBroker),
        },
        ...(dataBroker.archivedAt
          ? [
              {
                id: "unarchive",
                type: "button" as const,
                icon: <Unarchive />,
                tooltipLabel: "Unarchive Data Broker",
                onClick: () => onUnarchive(dataBroker.id),
                confirm: {
                  title: `Unarchive ${dataBroker.name}`,
                  description: `Unarchive ${dataBroker.name}?`,
                },
              },
            ]
          : [
              {
                id: "archive",
                type: "button" as const,
                icon: <Archive />,
                tooltipLabel: "Archive Data Broker",
                onClick: () => onArchive(dataBroker.id),
                confirm: {
                  title: `Archive ${dataBroker.name}`,
                  description: `Archive ${dataBroker.name}?`,
                },
              },
            ]),
      ]}
      emptyState="No data brokers found"
      totalCount={totalCount}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      page={page}
      onChangePage={handleChangePage}
    />
  );
}
